// Published content captured from production on October 23, 2026.
export function ProgramBanks() {
    return (
        <>
            <h2 id="SweepBanks">Cash Sweep Program Banks</h2>
            <p>Below are the banks that participate in our Cash Sweep Program:</p>
            <div className="overflow-x-auto"><table>
            <thead>
            <tr>
            <th>Bank</th>
            <th>Address</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>BankUnited, N.A</td>
            <td>14817 Oak Ln<br />Miami Lakes, FL 33016</td>
            </tr>
            <tr>
            <td>East West Bank</td>
            <td>135 N Los Robles Ave<br />F17<br />Pasadena, CA 91101</td>
            </tr>
            <tr>
            <td>Goldman Sachs Bank USA</td>
            <td>200 West Street<br />New York, NY 10282</td>
            </tr>
            <tr>
            <td>Israel Discount Bank</td>
            <td>1114 Avenue Of The Americas<br />New York, NY 10036</td>
            </tr>
            <tr>
            <td>First Bank</td>
            <td>2465 Kuser Rd<br />Hamilton, NJ 08690</td>
            </tr>
            <tr>
            <td>Merrick Bank</td>
            <td>10705 S Jordan Gateway, Suite 200<br />South Jordan, UT 84095</td>
            </tr>
            <tr>
            <td>Simmons First National Bank</td>
            <td>501 S Main St<br />Pine Bluff, AR 71601</td>
            </tr>
            <tr>
            <td>Truist Bank</td>
            <td>214 N Tryon St<br />Charlotte, NC 28202</td>
            </tr>
            <tr>
            <td>Truxton Trust Company</td>
            <td>20 Burton Hills Blvd, Suite 200<br />Nashville, TN 37215</td>
            </tr>
            <tr>
            <td>United Community Bank</td>
            <td>200 E Camperdown Way<br />Greenville, SC 29601</td>
            </tr>
            </tbody>
            </table></div>
            <p>In addition to the Cash Sweep Program Banks your funds can be held by us directly as part of the Cash Sweep Program. When we hold your funds they are insured by SIPC (subject to SIPC limitations) and supplemental insurance protections.</p>
            <hr />
        </>
    );
}
